import React from "react";
import { Routes, Route } from "react-router-dom";
import { adminRouteForSecondLayout, adminRoutes } from "./routes";
import OrganizationLayout from "../layouts/OrganizationLayout";
import MainLayout from "../layouts/mainLayout";

const AdminRoutes = () => {
  return (
    <>
      <Routes>
        <Route element={<OrganizationLayout />}>
          {
            adminRouteForSecondLayout.map(({ path, element }, index)=>(
              <Route key={index} path={path} element={element} />
            ))
          }
        </Route>
      </Routes>
      <Routes>
        <Route element={<MainLayout />}>
          {
            adminRoutes.map(({ path, element }, index)=>(
              <Route key={index} path={path} element={element} />
            ))
          }
        </Route>
      </Routes>
    </>
  );
};

export default AdminRoutes;

// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import ProtectedRoute from "./ProtectedRoute";
// import AdminDashboard from "../pages/AdminDashboard";
// import AdminSettings from "../pages/AdminSettings";
// import NotFound from "../pages/NotFound";

// const AdminRoutes = () => {
//   return (
//     <Routes>
//       <Route path="/admin/:orgname/:id" element={<ProtectedRoute element={<AdminDashboard />} requiredRole="admin" />} />
//       <Route path="/admin/settings" element={<ProtectedRoute element={<AdminSettings />} requiredRole="admin" />} />
//       <Route path="*" element={<NotFound />} />
//     </Routes>
//   );
// };

// export default AdminRoutes;
